import mixinBase from './mixin-base';
import SelectBase from '@x3/js/side/0_mixin/select-base.vue';

let deepFor = (function() {
  let args = [];
  return function deepForEach(targetArr, deepKeys, callback) {
    targetArr.forEach(item => {
      let keys = app.tool.clone(deepKeys),
        key = keys.shift();
      args.push(item);
      key ? deepForEach(item[key], keys, callback) : callback.apply(this, args);
      args.pop();
    });
  };
})();

const sideMixin = {
  mixins: [mixinBase],
  components: {
    SelectBase,
  },
  data() {
    return {
      // 用于保存传入的选中的id数组
      rawIds: '',
      // 实时选中的id数组
      ids: [],
      // 实时选中的项目数组
      list: [],

      // 可选数据
      listAll: [],
      total: 0,

      api: '',
      params: {},
      // 配置项
      config: {
        // 是否单选功能
        radio: false,
        // 是否必须至少选择一项
        must: false,
      },
      filter: {},

      mixinConf: {
        idKey: 'id',
        deepKeys: [],
      },
    };
  },
  computed: {
    // 是否全选当前项目
    checkAll: {
      get() {
        let len = 0;
        if (this.mixinConf.deepKeys.length > 0) {
          let forKeys = app.tool.clone(this.mixinConf.deepKeys),
            lenKey = forKeys.pop();

          deepFor(this.listAll, forKeys, function() {
            let lastItem = arguments[arguments.length - 1];
            len += lastItem[lenKey].length;
          });
        } else {
          len = this.listAll.length;
        }
        return len == this.ids.length;
      },
      set(val) {
        this.ids = [];
        this.list = [];
        if (val) {
          let that = this;
          deepFor(this.listAll, this.mixinConf.deepKeys, function() {
            let item = that.getItem.apply(null, arguments);
            that.ids.push(item[that.mixinConf.idKey]);
            that.list.push(item);
          });
        }
      },
    },
  },
  methods: {
    async mixinInit() {
      let opts = this.$vxRoute.meta.options || {},
        optkeys = Object.keys(opts);

      if (opts.api) {
        this.api = opts.api;
      }
      if (opts.params) {
        this.params = Object.assign(this.params, opts.params);
      }
      if (opts.config) {
        this.config = Object.assign(this.config, opts.config);
      }
      if (opts.filter) {
        this.filter = Object.assign(this.filter, opts.filter);
      }

      if (optkeys.includes('id')) {
        // 如果传了id参数，则默认为单选
        this.config.radio = true;
        if (opts.id) {
          let rid = Number(opts.id);
          this.rawIds = [rid];
          this.ids = [rid];
        }
      } else if (opts.ids) {
        let rids = opts.ids.map(Number);
        this.rawIds = app.tool.clone(rids);
        this.ids = app.tool.clone(rids);
        if (opts.list) {
          this.list = app.tool.clone(opts.list);
        } else {
          throw new Error('需要回显的场景，必须传递list参数，值应该为当前选中项目的数组');
        }
      }
      // console.log('side mixin ... mixinInit ');
    },
    // 业务层可能需要改写
    getItem() {
      return arguments[0];
    },
    clickHandler() {
      let item = this.getItem.apply(null, arguments);

      if (this.config.radio) {
        if (this.ids.includes(item[this.mixinConf.idKey])) {
          this.ids.splice(0, 1);
          this.list.splice(0, 1);
        } else {
          this.ids = [item[this.mixinConf.idKey]];
          this.list = [item];
        }
      } else {
        if (this.ids.includes(item[this.mixinConf.idKey])) {
          let idx = this.ids.indexOf(item[this.mixinConf.idKey]);
          this.ids.splice(idx, 1);
          this.list.splice(idx, 1);
        } else {
          this.ids.push(item[this.mixinConf.idKey]);
          this.list.push(item);
        }
      }
    },
    // 是否进行了有效选择
    getIsChange() {
      let rawIds = [...this.rawIds].sort();
      let ids = [...this.ids].sort();
      return JSON.stringify(ids) !== JSON.stringify(rawIds);
    },

    // 最终选择的结果
    getRet() {
      // console.log('side mixin ... getRet ');
      let ret = false;
      if (this.config.must && this.ids.length == 0) {
        vant.Toast('请至少选择一项，或点击取消');
        ret = 'occlude';
      } else {
        // 如果没发生变化，不用返回值
        if (this.getIsChange()) {
          if (this.config.radio) {
            ret = this.list[0] || null;
          } else {
            ret = {
              ids: this.ids,
              list: this.list,
            };
          }
        }
      }
      return ret;
    },
  },
  created() {
    this.mixinInit();
  },
};

export default sideMixin;
